import {
  MsMarketType,
  MsSubDomainType,
  NavCountriesInterface,
  NavLinkInterface,
} from "@/types/navigation";
import { Currency } from "@/types/types";

export const currentMsMarket = "" as MsMarketType;

export const currentMsSubDomain = "" as MsSubDomainType;

export const currentMsCurrencyCode = "" as Currency;

export const countries = [] as NavCountriesInterface[];

export const blogLink = null as NavLinkInterface | null;
